import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import './Search.scss'

export function SearchBox({
  search,
  setSearch,
  onFocus,
  placeholder
}: {
  search: string
  setSearch: (text: string) => void
  onFocus?: () => void
  placeholder?: string
}) {
  const onSearchKeyDown = React.useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') onFocus?.()
    },
    [onFocus]
  )
  return (
    <div className="poe-search">
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={onSearchKeyDown}
        spellCheck={false}
        placeholder={placeholder}
      />
      <FontAwesomeIcon
        className="poe-close"
        icon={search.length ? faTimes : faSearch}
        onClick={() => setSearch('')}
      />
    </div>
  )
}
